var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8299",
    transform: "translate(-649 -704)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_561",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(649 704)",
    fill: "#e7ebee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-pencil",
    d: "M10.093,0,8.411,1.682l3.364,3.364,1.682-1.682ZM6.729,3.364,0,10.093v3.364H3.364l6.729-6.729Z",
    transform: "translate(657.271 711.271)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.835d5f0c36d0c15cb54fc6a52d024ae4.svg";
export { ForwardRef as ReactComponent };